var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: _vm.form.id ? "修改产品" : "新增产品",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "110px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入名称" },
                model: {
                  value: _vm.form.name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.status,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("启用")
                  ]),
                  _c("el-radio", { attrs: { label: 0, border: "" } }, [
                    _vm._v("禁用")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "sort" } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  clearable: "",
                  placeholder: "请输入排序"
                },
                model: {
                  value: _vm.form.sort,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "sort", $$v)
                  },
                  expression: "form.sort"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "描述", prop: "description" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入描述" },
                model: {
                  value: _vm.form.description,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "图片", prop: "icon" }
            },
            [
              _c("uploadImage", {
                attrs: { value: _vm.fileList },
                on: {
                  input: function($event) {
                    return _vm.imgChange($event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addDomain } },
                [_vm._v("添加环境")]
              )
            ],
            1
          ),
          _vm._l(_vm.form.environments, function(domain, index) {
            return _c(
              "div",
              {
                key: index + "r",
                staticClass: "lodingItemT",
                staticStyle: { display: "flex", width: "100%" }
              },
              [
                _c(
                  "div",
                  { staticClass: "popover", staticStyle: { width: "100%" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "environments." + index + ".env_id",
                          label: "环境",
                          rules: _vm.rules.env_id
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: domain.env_id,
                              callback: function($$v) {
                                _vm.$set(domain, "env_id", $$v)
                              },
                              expression: "domain.env_id"
                            }
                          },
                          _vm._l(_vm.environmentsList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "environments." + index + ".status",
                          label: "状态"
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: domain.status,
                              callback: function($$v) {
                                _vm.$set(domain, "status", $$v)
                              },
                              expression: "domain.status"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: 1, border: "" } },
                              [_vm._v("启用")]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: 0, border: "" } },
                              [_vm._v("禁用")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100% !important" },
                        attrs: {
                          prop: "environments." + index + ".url",
                          rules: _vm.rules.url,
                          label: "跳转链接"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            clearable: "",
                            placeholder: "请输入跳转链接"
                          },
                          model: {
                            value: domain.url,
                            callback: function($$v) {
                              _vm.$set(domain, "url", $$v)
                            },
                            expression: "domain.url"
                          }
                        }),
                        _c("el-button", {
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            size: "mini",
                            type: "danger",
                            circle: "",
                            icon: "el-icon-delete"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removeDomain(domain)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100% !important" },
                        attrs: {
                          prop: "environments." + index + ".description",
                          label: "描述"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "请输入描述" },
                          model: {
                            value: domain.description,
                            callback: function($$v) {
                              _vm.$set(domain, "description", $$v)
                            },
                            expression: "domain.description"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          })
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.hide()
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.clearData(true)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitData()
                }
              }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }